import React from "react";
import styled from "styled-components/macro";

const StyledSvg = styled.svg`
  width: var(--icon-size);
  height: var(--icon-size);
`;

export const PurchaseOrderIcon: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <>
      <StyledSvg
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <mask
          id="mask0_1331_169984"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1331_169984)">
          <path d="M5 18C4.36111 18 3.86806 17.8299 3.52083 17.4896C3.17361 17.1493 3 16.6528 3 16V13H5V2L6.2 3.20833L7.4 2L8.6 3.20833L9.8 2L11 3.20833L12.2 2L13.4 3.20833L14.6 2L15.8 3.20833L17 2V15.75C17 16.4028 16.7847 16.941 16.3542 17.3646C15.9236 17.7882 15.3889 18 14.75 18H5ZM14.75 16.5C14.9722 16.5 15.1528 16.434 15.2917 16.3021C15.4306 16.1701 15.5 15.9861 15.5 15.75V4.5H6.5V13H14V15.75C14 15.9861 14.0694 16.1701 14.2083 16.3021C14.3472 16.434 14.5278 16.5 14.75 16.5ZM7.5 7.5V6H12V7.5H7.5ZM7.5 10V8.5H12V10H7.5ZM13.75 7.5C13.5556 7.5 13.3819 7.42854 13.2292 7.28563C13.0764 7.14271 13 6.96563 13 6.75438C13 6.54313 13.0764 6.36458 13.2292 6.21875C13.3819 6.07292 13.559 6 13.7604 6C13.9618 6 14.1354 6.07146 14.2812 6.21437C14.4271 6.35729 14.5 6.53437 14.5 6.74562C14.5 6.95687 14.4281 7.13542 14.2844 7.28125C14.1406 7.42708 13.9625 7.5 13.75 7.5ZM13.75 10C13.5556 10 13.3819 9.92854 13.2292 9.78562C13.0764 9.64271 13 9.46563 13 9.25438C13 9.04313 13.0764 8.86458 13.2292 8.71875C13.3819 8.57292 13.559 8.5 13.7604 8.5C13.9618 8.5 14.1354 8.57146 14.2812 8.71437C14.4271 8.85729 14.5 9.03437 14.5 9.24562C14.5 9.45687 14.4281 9.63542 14.2844 9.78125C14.1406 9.92708 13.9625 10 13.75 10ZM5 16.5H12.5V14.5H4.5V16C4.5 16.2361 4.52431 16.3785 4.57292 16.4271C4.62153 16.4757 4.76389 16.5 5 16.5Z" />
        </g>
      </StyledSvg>
    </>
  );
};
